import { Component, OnInit, ViewEncapsulation } from "@angular/core";

import { AppService } from "./services/app.service";
import { SharedService } from "./services/shared.service";
import { Topbar } from "./model/topbar";
import { Router, NavigationEnd } from "@angular/router";

declare var window: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  encapsulation: ViewEncapsulation.Emulated,
  providers: [SharedService],
})
export class AppComponent implements OnInit {
  constructor(private sharedService: SharedService, private router: Router) {}

  ngOnInit() {
    window.openedWindows = [];
    window._open = window.open;
    window.open = function (url, name, params) {
      window.openedWindows[0] = window._open(url, name, params);
      return window.openedWindows[0];
    };

    const key: string | null = localStorage.getItem("key");
    const header: Topbar | null = JSON.parse(localStorage.getItem("header"));
    if (key != null && header != null) {
      this.sharedService.updateHeader(header.user_id, key);
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
  }

  onActivate(event) {
    // window.scroll(0,0);

    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    //or document.body.scrollTop = 0;
    //or document.querySelector('body').scrollTo(0,0)
    //

    document.body.scrollTop = 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts